import walletFinancialPositionsMessages from '../../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../../column';
import { TraditionalPoliciesRevaluedProduct } from '../../financial-insurance-macro-category';

export const mobileTraditionalPoliciesRevaluedColumns: Column<TraditionalPoliciesRevaluedProduct>[] =
  [
    {
      headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
      key: 'productName',
      type: 'string',
    },
    {
      headerLabel:
        walletFinancialPositionsMessages.tableHeaderCounterValueShort,
      key: 'equivalent',
      type: 'amount',
    },
  ];
